/** @format */
import { ModalProps } from './types';

export const curveDisplay = ({ isClosable }: ModalProps) => {
    if (isClosable) return 'block';

    return 'none';
};
